import { LoMsg } from '@/api/Msg';
import { LoginViaUserResp } from '@/types/Login';
import { message } from 'antd';
import { Base64 } from 'js-base64';

export function getBaseUrl(url: string): string | undefined {
  if (!url) return url
  // TODO polyfill
  if (!url.startsWith("http")) return url;

  const protocolSplit = url.split("//");
  if (protocolSplit.length < 2) return undefined

  const host = protocolSplit[1].split("/")
  return protocolSplit[0] + "//" + host[0]
}

export function redirect(currentUrl: string, url: string): string {
  if (!url || url.startsWith("http")) return url
  const base = getBaseUrl(currentUrl)
  console.log("redirect to: ", base + url);
  return base + url
}

function loginErrorMessage(resp?: LoginViaUserResp): string {
  return resp?.message
    || LoMsg("SVC_NOT_AVAILABLE");
}

export function handleProto(resp: LoginViaUserResp, appId: string): void {

  console.log("handle proto", resp)

  if (!resp || resp.code != "0") {
    const errorMessage = loginErrorMessage(resp);
    console.log(errorMessage)
    message.error(errorMessage);
    console.log(errorMessage);
    return;
  }
  message.success(`${LoMsg("LOGIN_SUCCESS")}`);
  console.log(`登录成功即将跳转 ${resp.redirect}`);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if ((resp as any).protocol != "saml") {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.location.href = redirect(window.location.href, (resp as any).redirect)
    // window.location.href = (resp.data.data as any).redirect;
  } else {
    // 创建一个 form 
    const frmSaml = document.createElement("form");
    frmSaml.id = "frmSaml";
    frmSaml.name = "frmSaml";
    document.body.appendChild(frmSaml);
    const input = document.createElement("input");
    input.type = "text";
    input.name = "SAMLRequest";
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    input.value = (resp.data as any).samlRequest
    frmSaml.appendChild(input);
    frmSaml.method = "POST";
    frmSaml.action = redirect(window.location.href, `/protocol/saml/${appId}/login`);
    frmSaml.submit();
    document.body.removeChild(frmSaml);
  }
}

export function parseQueryString(str?: string): { [key: string]: string } {
  const { search } = window.location;
  const params: { [key: string]: string } = {};
  const queryString = str ? str : search.split('?')[1];
  if (queryString) {
    const keyValuePairs = queryString.split('&');
    for (let i = 0; i < keyValuePairs.length; i++) {
      const pair = keyValuePairs[i].split('=');
      const key = decodeURIComponent(pair[0]);
      const value = decodeURIComponent(pair.slice(1).join('=') || '');
      params[key] = value;
    }
  }
  return params;
}

const d2 = (v: number) => (v > 9 ? v : `0${v}`)
export function formatDate(str: string, format = 'datetime'): string {
  if (!str) return str;
  const d = new Date(str)
  return `${d.getFullYear()}-${d2(d.getMonth() + 1)}-${d.getDate()} ${d2(d.getHours())}:${d2(d.getMinutes())}:${d2(d.getSeconds())}`
}

export function randomString(len: number): string {
  len = len || 32;
  const $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz1234567890';
  const maxPos = $chars.length;
  let pwd = '';
  for (let i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}

export function firstOf(
  items: { key: string, value: string }[],
  vals: string[],
) {
  return items.find(item => vals.includes(item.key))?.value;
}

export function loadScript(src: string) {
  return new Promise((resolve, reject) => {
    // @see: https://stackoverflow.com/questions/8578617
    let scriptEle = document.createElement('script');
    scriptEle.type = 'text/javascript';
    scriptEle.async = false;
    scriptEle.src = src;
    scriptEle.onload = resolve;
    scriptEle.addEventListener('load', resolve);
    scriptEle.addEventListener('error', e => reject(e.error));
    document.head.appendChild(scriptEle);
  });
}

export const isMobile = (() => {
  const screenWidth = window.innerWidth;
  const { appId, mode } = parseQueryString();
  if (appId == 'preview' && mode === 'mobile') return true;
  return screenWidth <= 750;
})();

export const Social1Codes = [
  'wechat',
  'dingding',
  'qywechat',
  'alipay',
  'qq',
  'douyin',
  'weibo',
  'gitee',
  'facebook',
  'feishu',
  'welink',
];
export const Social2Codes = [
  'google',
  'github',
  'twitter_x',
];

export const SocialCodes = [
  'customized_scan_qr_kk',
  ...Social1Codes,
  ...Social2Codes,
];

export const encodePwd = (pwd?: string) => {
  const encoded = Base64.encode(pwd ?? '');
  return `$ENCV0$${Base64.encode(encoded)}`;
}
